module.exports = __webpack_public_path__ + "static/img/witness-teens-1.5c2c1c06.png";